module.exports = __webpack_public_path__ + "fonts/boxicons.15fa2fe8.ttf";